/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Notebook } from '../models/Notebook';

export class ListNotebooksResponse {
  'notebooks'?: Array<Notebook>;
  /**
  * Token for fetching the next page
  */
  'nextToken'?: string | null;
  /**
  * Total number of notebooks
  */
  'totalCount'?: number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "notebooks",
      "baseName": "notebooks",
      "type": "Array<Notebook>",
      "format": ""
    },
    {
      "name": "nextToken",
      "baseName": "nextToken",
      "type": "string",
      "format": ""
    },
    {
      "name": "totalCount",
      "baseName": "totalCount",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListNotebooksResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

